export default __webpack_public_path__ + "locales/si/JavascriptSdk.json?hash=215f3d6d823e083dd931ac4b8444fba4";